import {
  UilCreateDashboard,
  UilUsersAlt,
  UilBagAlt,
  UilFileCheck,
  UilMoneyStack,
  UilMoneyWithdrawal,
  UilQuestionCircle,
  UilBell,
  UilMonitor,
  UilHeadphones,
  UilDesktop,
  UilMessage,
  UilMapMarker,
} from '@iconscout/react-unicons';
import { Menu } from 'antd';
import React from 'react';

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import propTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Constants } from '../utility/constants';
// import { changeDirectionMode, changeLayoutMode, changeMenuMode } from '../redux/themeLayout/actionCreator';

function MenuItems() {
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }
  const topMenu = false;

  const path = '/admin';
  const pathName = window.location.pathname;
  const pathArray = pathName && pathName !== '/' ? pathName.split(path) : [];
  const mainPath = pathArray.length > 1 ? pathArray[1] : '';
  const mainPathSplit = mainPath.split('/');
  const Roles = Constants.admin.role;

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    // getItem('Dashboard', 'dashboard', !topMenu && <UilCreateDashboard />, null),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/`}>Dashboard</NavLink>, 'dashboard', !topMenu && <UilCreateDashboard />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/roles`}>Roles</NavLink>, 'roles', !topMenu && <UilBagAlt />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/parent-company`}>Parent Company</NavLink>, 'Parent Company', !topMenu && <UilBagAlt />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/pairs`}>Pairs</NavLink>,
      'pairs',
      !topMenu && <UilCreateDashboard />,
      null,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/sell-pairs`}>Sell Pairs</NavLink>,
      'sell-pairs',
      !topMenu && <UilCreateDashboard />,
      null,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/assets`}>Assets</NavLink>,
      'assets',
      !topMenu && <UilCreateDashboard />,
      null,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/sell-assets`}>Sell Assets</NavLink>,
      'sell-assets',
      !topMenu && <UilCreateDashboard />,
      null,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/users`}>Users</NavLink>, 'users', !topMenu && <UilUsersAlt />),
    // getItem('Users', 'users', !topMenu && <UilUsersAlt />, null),
    [Roles.superAdmin, Roles.verification_team].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/verification`}>Verification</NavLink>,
      'verification',
      !topMenu && <UilFileCheck />,
    ),
    [Roles.superAdmin, Roles.finance].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/deposit`}>Deposit</NavLink>, 'deposit', !topMenu && <UilMoneyStack />),
    [Roles.superAdmin, Roles.finance].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/withdrawal`}>Withdraw</NavLink>, 'withdraw', !topMenu && <UilMoneyWithdrawal />),
    // [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    //   getItem(<NavLink to={`${path}/bonus-code`}>Bonus</NavLink>, 'bonus-code', !topMenu && <UilTag />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/configure-payment-gateways`}>Configure-Payment gateways</NavLink>,
      'configure-payment-gateways',
      !topMenu && <UilDesktop />,
    ),
    [Roles.superAdmin, Roles.support].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/support`}>Support</NavLink>, 'support', !topMenu && <UilHeadphones />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/faq`}>FAQs</NavLink>, 'faq', !topMenu && <UilQuestionCircle />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/notifications`}>Notifications</NavLink>, 'notifications', !topMenu && <UilBell />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/app-banners`}>App Banners</NavLink>,
      'app-banners',
      !topMenu && <UilMonitor />,
      null,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(
      <NavLink to={`${path}/stuck-payments`}>Stuck Payments</NavLink>,
      'stuck-payments',
      !topMenu && <UilMoneyWithdrawal />,
    ),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/send-email`}>Send Email</NavLink>, 'send-email', !topMenu && <UilMessage />),
    [Roles.superAdmin].includes(Cookies.get(`role`)) &&
    getItem(<NavLink to={`${path}/treasure-hunt`}>Treasure Hunt</NavLink>, 'treasure-hunt', !topMenu && <UilMapMarker />),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
            `${mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
            }`,
          ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
